class ErrorHelperStatic {
    ifUserError(error: any, ifUserErrorCallback: ((userError: string) => void)): boolean {
        const responseData = error?.response?.data
        const errorMessage = typeof responseData === 'string' || responseData instanceof String
            ? responseData
            : responseData?.message
        if (errorMessage && (typeof errorMessage === 'string' || errorMessage instanceof String)) {
            const userMessage = errorMessage.match("^UserMessage=(.+)$")
            if (userMessage && userMessage.length == 2) {
                ifUserErrorCallback(userMessage[ 1 ])
                return true
            }
        }
        return false
    }
}
const ErrorHelper = new ErrorHelperStatic()
export default ErrorHelper
